import React from "react";
import { useTranslation } from "react-i18next";
import { Button, Dialog, DialogActions, DialogContent } from "@mui/material";


const MessagePopup: React.FC<{open: boolean, content: string, onClose: () => void}> = ({open, content, onClose}) => {

    const { t } = useTranslation('common');

    return (
        <>
        <Dialog open={open}>
            <DialogContent>
                <p>{t(content)}</p>
            </DialogContent>
            <DialogActions>
                <Button onClick={onClose} color="secondary">
                    {t('close')}
                </Button>
            </DialogActions>
        </Dialog>
        </>
    );
};

export default MessagePopup;
